import React from "react";
import "./Events.css";
import FeaturedEvent from "../FeaturedEvent";
import UpcomingEvents from "../UpcomingEvents";
import Newsletter from "../Newsletter";
import Footer from "../Footer";

const Events = () => {
  return (
    <main className="events-page">
      <section className="events-intro">
        <h1>Gyere el eseményeinkre!</h1>
        <p>
          Csatlakozz közelgő eseményeinkhez, konferenciáinkhoz, találkozóinkhoz és sok
          máshoz. Akár egy képernyőre, akár egy hozzád közeli városba érkezünk,
          mindenki talál magának valót.
        </p>
      </section>

      <FeaturedEvent />
      <UpcomingEvents />
      <Newsletter />
      <Footer />
    </main>
  );
};

export default Events;
